import { render, staticRenderFns } from "./Ambience.vue?vue&type=template&id=8c8583b0"
import script from "./Ambience.vue?vue&type=script&lang=js"
export * from "./Ambience.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c8583b0')) {
      api.createRecord('8c8583b0', component.options)
    } else {
      api.reload('8c8583b0', component.options)
    }
    module.hot.accept("./Ambience.vue?vue&type=template&id=8c8583b0", function () {
      api.rerender('8c8583b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/Ambience.vue"
export default component.exports